import { ref, onUnmounted } from 'vue';

export const useResendTimer = (intervalSeconds: number = 90) => {
    const secondsToWait = ref(intervalSeconds);
    let timerInterval: ReturnType<typeof setInterval> | undefined;

    const startTimer = () => {
        if (timerInterval) clearInterval(timerInterval);

        timerInterval = setInterval(() => {
            secondsToWait.value--;
            if (secondsToWait.value <= 0) {
                clearInterval(timerInterval);
            }
        }, 1000);
    };

    const resetTimer = () => {
        secondsToWait.value = intervalSeconds;
        startTimer();
    };

    const clearTimer = () => {
        if (timerInterval) {
            clearInterval(timerInterval);
        }
        secondsToWait.value = 0;
    };

    const canResend = () => secondsToWait.value <= 0;

    // Start the timer immediately
    startTimer();

    // Clean up on component unmount
    onUnmounted(() => {
        if (timerInterval) {
            clearInterval(timerInterval);
        }
    });

    return {
        secondsToWait,
        resetTimer,
        clearTimer,
        canResend,
    };
};
